module.exports = __webpack_public_path__ + "static/media/Changes occurs at AAA model.f4b20ae6.png";